import { createStyles } from '@mantine/core';
import useTranslation from 'next-translate/useTranslation';

import { Routes } from '~/domains/common/constants/routes';
import type { FullContest } from '~/domains/contest/domains/services/interfaces/full-contest.interface';
import Container from '~/domains/design-system/Container';
import dt from '~/testing';

import GamecenterMarketplaceNavItem from './GamecenterMarketplaceNavItem';
import {
  GamecenterNonScheduledNavList,
  GamecenterNonScheduledNavListItem,
} from './GamecenterNonScheduledNavComponents';

const useStyles = createStyles((theme) => ({
  container: {
    background: theme.colors.gray[9],
    borderTop: `1px solid ${theme.colors.gray[8]}`,
    overflow: 'auto',
  },
}));

function PlayerTierNonScheduledNav({ contest }: { contest: FullContest }) {
  const { t } = useTranslation('contest');
  const { classes } = useStyles();
  const contestId = contest.id;
  const isSpectatorMode = contest?.public_viewing && contest?.entries.user === 0;
  const showAvailabilityTab = typeof contest.settings?.pickReuseLimit === 'number';

  return (
    <div className={classes.container}>
      <Container>
        <GamecenterNonScheduledNavList>
          <GamecenterNonScheduledNavListItem
            href={Routes.gamecenterStandingsOverall(contestId)}
            data-test-id={dt.contest.gamecenter.common.navigation.nonScheduled.standings}
            activeForRoutes={[Routes.gamecenterStandingsSlates(contestId)]}
          >
            {t('gamecenter.layoutNonScheduled.nav.standings')}
          </GamecenterNonScheduledNavListItem>
          {isSpectatorMode ? null : (
            <GamecenterNonScheduledNavListItem
              href={Routes.gamecenterEntriesOverall(contestId)}
              data-test-id={dt.contest.gamecenter.common.navigation.nonScheduled.entries}
            >
              {t('gamecenter.layoutNonScheduled.nav.entries')}
            </GamecenterNonScheduledNavListItem>
          )}
          {showAvailabilityTab && (
            <GamecenterNonScheduledNavListItem
              href={Routes.gamecenterAvailabilityAvailable(contestId)}
              activeForRoutes={[Routes.gamecenterAvailabilityUnavailable(contestId)]}
              data-test-id={dt.contest.gamecenter.common.navigation.nonScheduled.availability}
            >
              {t('gamecenter.layoutNonScheduled.nav.availability')}
            </GamecenterNonScheduledNavListItem>
          )}
          <GamecenterNonScheduledNavListItem
            href={Routes.gamecenterPlayers(contestId)}
            data-test-id={dt.contest.gamecenter.common.navigation.nonScheduled.players}
          >
            {t('gamecenter.layoutNonScheduled.nav.players')}
          </GamecenterNonScheduledNavListItem>
          <GamecenterMarketplaceNavItem contestId={contestId} />
          <GamecenterNonScheduledNavListItem
            href={Routes.contestDetail(contestId)}
            data-test-id={dt.contest.gamecenter.common.navigation.nonScheduled.detail}
          >
            {t('gamecenter.layoutNonScheduled.nav.detail')}
          </GamecenterNonScheduledNavListItem>
        </GamecenterNonScheduledNavList>
      </Container>
    </div>
  );
}

export default PlayerTierNonScheduledNav;
